import ViewProfilePage from "./viewProfilePage.container";

export default ViewProfilePage;
